import { Outlet } from 'react-router-dom';
import {
  LayoutDashboard, FileText, Receipt, Banknote,
  Building2, CalendarCheck, BookOpen
} from 'lucide-react';
import Sidebar from './Sidebar';
import TopBar from './TopBar';
import { useShop } from '../../hooks/useShop';
import { useDashboard } from '../../hooks/useDashboard';
import { useAuth } from '../../contexts/AuthContext';

export default function BookkeeperShell() {
  const { user } = useAuth();
  const { shops, currentShopId, switchShop } = useShop();
  const { data: dashboard, loading, refresh } = useDashboard(currentShopId);

  const sections = [
    {
      label: 'Bill Pay',
      items: [
        { to: '/bookkeeper', end: true, label: 'Dashboard', icon: <LayoutDashboard /> },
        { to: '/bookkeeper/statements', label: 'Statements', icon: <FileText />, badge: 4 },
        { to: '/bookkeeper/cod-checks', label: 'COD Checks', icon: <Receipt />, badge: 12 },
        { to: '/bookkeeper/bill-pay', label: 'Bill Pay Queue', icon: <Banknote /> },
      ],
    },
    {
      label: 'Workflow',
      items: [
        { to: '/bookkeeper/weekly-close', label: 'Weekly Close', icon: <CalendarCheck /> },
        { to: '/bookkeeper/vendors', label: 'Vendors', icon: <Building2 /> },
      ],
    },
    {
      label: 'References',
      items: [
        { to: '/bookkeeper/audit-trail', label: 'Audit Trail', icon: <BookOpen /> },
      ],
    },
  ];

  return (
    <div className="min-h-screen flex bg-[var(--color-cream-100)] font-sans">
      <Sidebar
        brand={{ initials: 'R', name: 'Reconciliation Hub', tagline: 'Bookkeeper workspace' }}
        sections={sections}
      />
      <div className="flex-1 min-w-0 flex flex-col">
        <TopBar
          user={user || {}}
          currentShop={currentShopId}
          shops={shops}
          onShopChange={switchShop}
          notifications={0}
          onRefresh={refresh}
        />
        <main className="flex-1 overflow-y-auto">
          <div className="max-w-[1400px] mx-auto px-6 py-8">
            <Outlet context={{ dashboard, loading, refresh }} />
          </div>
        </main>
      </div>
    </div>
  );
}
